var getPayByReturnUrl = function (alipay_notify_url: any) {
  // console.log(alipay_notify_url)
  if (alipay_notify_url != undefined) {
    if (alipay_notify_url.app_id == "2021005177637593") {
      return "支付宝-斯塔瑞（上海）文化创意有限公司"
    } else if (alipay_notify_url.mchid == "1648390365") {
      return "微信支付-斯塔瑞（上海）文化创意有限公司"
    } else if (alipay_notify_url.app_id == "2021005176616470") {
      return "支付宝-一击懒（上海）动漫文化传播有限公司"
    } else if (alipay_notify_url.app_id == "2021004182623817") {
      return "支付宝-水豚小怪兽（上海）动漫文化传播有限公司"
    } else if (alipay_notify_url.mchid == "1694702732") {
      return "微信支付-水豚小怪兽（上海）动漫文化传播有限公司"
    } else if (alipay_notify_url.app_id == "2021006130689307") {
      return "支付宝支付-广州街胎贸易有限公司"
    }else if (alipay_notify_url.mchid == "1738182728") {
      return "微信支付-广州街胎贸易有限公司"
    } else {
      return ""
    }
  } else {
    return ""
  }
}

export default getPayByReturnUrl